// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "474") return "static/js/vendor." + __webpack_require__.h() + ".production-0.10.0.js";
  // return url for filenames based on template
  return "static/js/async/" + ({"259": "__federation_expose_ClassAccess","296": "__federation_expose_ManagementEventsWrapper","395": "__federation_expose_live",}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".production-0.10.0.js"
}